import 'froala-editor/js/plugins/image.min.js'
import 'froala-editor/js/languages/de.js'
import 'froala-editor/js/languages/es.js'
import 'froala-editor/js/languages/it.js'
import 'froala-editor/js/languages/pl.js'
import 'froala-editor/js/languages/ja.js'
import 'froala-editor/js/languages/zh_cn.js'
import 'froala-editor/js/plugins/video.min.js'
import 'froala-editor/js/plugins/file.min.js'

import { getLocale } from 'utils/localstorage'

const lang = getLocale()

let froalaLanguage = ''

switch (lang) {
  case 'de':
    froalaLanguage = 'de'
    break
  case 'es':
    froalaLanguage = 'es'
    break
  case 'it':
    froalaLanguage = 'it'
    break
  case 'pl':
    froalaLanguage = 'pl'
    break
  case 'jp':
    froalaLanguage = 'ja'
    break
  case 'cn':
    froalaLanguage = 'zh_cn'
    break

  default:
    froalaLanguage = 'en'
    break
}

const config = {
  // Set Activation Key
  key: 'Kb3A3pC3B2E1C4D4B3oCd2ZSb1XHi1Cb2a1KIWCWMJHXCLSwG1G1B2A1B1D7B5E1D4H3==',
  // eslint-disable-next-line react/react-in-jsx-scope
  language: froalaLanguage,

  spellcheck: true, // Enables browser spellcheck for the text inside the editing box.

  attribution: false, // Remove the Powered By Froala message.
  // useClasses: false,  // When this options is disabled the edited content will have the external CSS properties converted to inline style.

  pasteAllowLocalImages: true, // Removes images that have local path (file://) on paste. Enabling this option might result in having mixed content on HTTPS websites.

  // // pastePlain option is enabled
  pastePlain: false,
  pasteDeniedAttrs: ['class', 'id', 'style'], // Attributes that are removed when pasting something into the rich text editor.
  wordDeniedAttrs: ['class', 'id', 'style'], // Attributes that are removed when pasting something into the rich text editor from Word.

  requestWithCORS: false, // Make AJAX requests using CORS. For more information refer to Cross-origin resource sharing.

  htmlSimpleAmpersand: false,
  // height set min and max
  heightMin: 200,
  heightMax: 550,
  htmlAllowedTags: [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'blockquote',
    'ul',
    'ol',
    'li',
    'img',
    'iframe',
    'a',
    'strong',
    'em',
    'u',
    's',
    'pre',
    'table',
    'tbody',
    'tr',
    'td',
    'br',
    'hr',
    'video',
  ],

  // Set the image upload parameter.
  imageUploadParam: 'file',

  // Set request type.
  imageUploadMethod: 'POST',

  // Set max image size to 5MB.
  imageMaxSize: 5 * 1024 * 1024,

  // Allow to upload PNG and JPG.
  imageAllowedTypes: ['jpeg', 'jpg', 'png', 'gif'],

  // Set the video upload parameter.
  videoUploadParam: 'file',

  // Set request type.
  videoUploadMethod: 'POST',

  // Set max video size to 1024MB or 1GB.
  videoMaxSize: 1024 * 1024 * 1024,

  videoResponsive: true,
  videoResize: true,

  // Allow to upload MP4, WEBM and OGG
  videoAllowedTypes: ['webm', 'mp4', 'mov', 'wmv', 'flv', 'avi', 'mkv', '3gp'],

  // Set the file upload parameter.
  fileUploadParam: 'file',

  // Set request type.
  fileUploadMethod: 'POST',

  // Set max file size to 20MB.
  fileMaxSize: 20 * 1024 * 1024,

  // Allow to upload any file.
  fileAllowedTypes: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    // Excel old versions
    'application/excel',
    'application/x-excel',
    'application/x-msexcel',
  ],
}

export default config
